import { FontIconName, IconButton } from "client/Components";
import { generateTrackingId } from "client/Misc/utils";
import { ReactElement } from "react";

export type OverviewLayoutKindSelectorProps = {
	value: AddressBookOverviewLayoutKind;
	onChange: (value: AddressBookOverviewLayoutKind) => void;
};

export const OverviewLayoutKindSelector = (props: OverviewLayoutKindSelectorProps): ReactElement => {
	const {
		value,
		onChange
	} = props;

	const { icon, nextValue } = layoutKindConfigurationMap[value];

	return (
		<IconButton
			kind="secondary"
			icon={icon}
			trackingId={generateTrackingId("layout-kind-selector", `|${value}`)}
			onClick={() => onChange(nextValue)}
			size="large"
		/>
	);
};
OverviewLayoutKindSelector.displayName = "OverviewLayoutKindSelector";

export enum AddressBookOverviewLayoutKind {
	Grid = 0,
	List = 1
}

const layoutKindConfigurationMap: Record<AddressBookOverviewLayoutKind, { icon: FontIconName; nextValue: AddressBookOverviewLayoutKind; }> = {
	[AddressBookOverviewLayoutKind.Grid]: { icon: "bars", nextValue: AddressBookOverviewLayoutKind.List },
	[AddressBookOverviewLayoutKind.List]: { icon: "grid-2", nextValue: AddressBookOverviewLayoutKind.Grid }
};
